var some = require('../array/virtual/some');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.some) ? some : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/some.js
// module id = 991
// module chunks = 0